import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdAutorenew, MdLens } from "react-icons/md";

import PropTypes from "prop-types";

import DataTable from "../Shared/DataTable";
import { Spinner } from "../Shared";
import { message } from "../../_constants";
import { tableFilters } from "../../_utils";

export class DomainsList extends Component {
  render() {
    const columns = [
     /*  {
        Header: "Id",
        accessor: "id"
      }, */
      {
        Header: "Code",
        accessor: "code"
      },
      {
        Header: "Description",
        accessor: "description"
      },
      {
        Header: "Status",
        accessor: "enabled",
        ...tableFilters.statusFilter,
        Cell: row => {
          return (
            <div>
              {row.original.enabled ? (
                <span>
                  <MdLens className="text-success" /> Enabled
                </span>
              ) : (
                <span>
                  <MdLens className="text-danger" /> Disabled
                </span>
              )}
            </div>
          );
        }
      }
    ];

    const { match, fetching, data, loadData, error } = this.props;

    return (
      <div>
        <Row>
          <Col sm="6">
            <h5 className="item-count">
              {data && data.count} Result(s) Found
            </h5>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <Button
                disabled={fetching}
                onClick={loadData}
                className="btn btn-primary btn-outline"
              >
                {fetching ? (
                  <Spinner />
                ) : (
                  <span>
                    <MdAutorenew size={20} /> Refresh
                  </span>
                )}
              </Button>{" "}
              <Link to={`${match.url}/add`} className="btn btn-primary">
                Add Domain
              </Link>
            </div>
          </Col>
        </Row>
        <hr />
        {error && <Alert color="danger">{message.OUTDATED_DATA}</Alert>}
        <DataTable
          columns={columns}
          loading={fetching}
          urlParams={match}
          data={data && data.modelList ? data.modelList : []}
          defaultPageSize={10}
        />
      </div>
    );
  }
}

DomainsList.proptypes = {
  match: PropTypes.object.isRequired,
  data: PropTypes.object,
  loadData: PropTypes.func,
  fetching: PropTypes.bool,
  fetched: PropTypes.bool,
  error: PropTypes.object
};

export default DomainsList;
